import { render } from "./Index.vue?vue&type=template&id=02d7d8f2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=02d7d8f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02d7d8f2"

export default script